import React from 'react';
import Image from 'next/image';
import { cn } from '@/shared/lib/cn';

interface StackedImagesProps {
  imageUrl: string;
  alt: string;
  renderCount: number;
  hasMultipleRenders: boolean;
  className?: string;
  sizes?: string;
}

export function StackedImages({
  imageUrl,
  alt,
  renderCount,
  hasMultipleRenders,
  className,
  sizes = '(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw',
}: StackedImagesProps) {
  if (!hasMultipleRenders) {
    return (
      <div
        className={cn(
          'relative w-full h-full overflow-hidden rounded-lg',
          className
        )}
      >
        <Image
          src={imageUrl}
          alt={alt}
          fill
          sizes={sizes}
          className="object-cover"
          loading="lazy"
          quality={75}
          priority={false}
        />
      </div>
    );
  }

  return (
    <div className={cn('relative w-full h-full', className)}>
      {/* Stack layers - show up to 2 background cards with better visual effect */}
      {renderCount > 2 && (
        <div className="absolute inset-0 transform translate-x-3 translate-y-3 bg-card rounded-lg shadow-md border border-border" />
      )}
      {renderCount > 1 && (
        <div className="absolute inset-0 transform translate-x-1.5 translate-y-1.5 bg-card rounded-lg shadow-sm border border-border" />
      )}

      {/* Main image with shadow for depth */}
      <div className="relative w-full h-full overflow-hidden rounded-lg shadow-lg border border-border">
        <Image
          src={imageUrl}
          alt={alt}
          fill
          sizes={sizes}
          className="object-cover"
          loading="lazy"
          quality={75}
          priority={false}
        />
      </div>
    </div>
  );
}
